import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderProductTaskDto, OrderServiceProxy, ProductLocationHistoryDto } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-product-history-view-information',
  templateUrl: './product-history-view-information.component.html',
  styleUrls: ['./product-history-view-information.component.scss']
})
export class ProductHistoryViewInformationComponent implements OnInit {
	@Input() orderWaitingMyApprove: OrderProductTaskDto;

	productHistories = new BehaviorSubject<ProductLocationHistoryDto[]>([]);
	sumAmount = new BehaviorSubject<number>(0);

	isLoading = new BehaviorSubject<boolean>(false);

	constructor(
		private modalService: NgbModal,
		private _orderService: OrderServiceProxy
	) { }

	ngOnInit() {
		console.log(this.orderWaitingMyApprove);

		this.getProductLocationHistories();

	}

	getProductLocationHistories() {

		this._orderService.getProductLocationHistories(this.orderWaitingMyApprove.productId, this.orderWaitingMyApprove.toAddressId)
		//this._orderService.getProductLocationHistories(this.orderWaitingMyApprove.productId, 103969)
			.subscribe(res => {
				console.log(res);
				this.isLoading.next(true);
				this.productHistories.next(res);

				let sumResult = res.reduce((sum, current) => sum + current.quantity, 0)
				this.sumAmount.next(sumResult);
			}, err => {

					this.isLoading.next(true);

			});
	}

	modalClose() {
		this.modalService.dismissAll();
	}

}
